import script from "./ScaleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScaleSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ScaleSelector.vue?vue&type=style&index=0&id=b353ada8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b353ada8"]])

export default __exports__